/* eslint-disable array-callback-return */
import { Component } from "react";
import { Link } from "react-router-dom";
import { iIcon } from "../../assets";
import config from "../../config/config";
import trackingService from "../../services/trackingService";
import "../ContentShortcuts/ContentShortcuts.css";

class MedicalInsightTileGenAIRec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCSModal: false,
      arrayOfInsightsReports: [],
      showInfo: false,
    };
  }
  async componentDidMount() {
    this.setState({
      arrayOfInsightsReports: config.iMedicalInsightsReports,
    });
  }
  componentDidUpdate = () => {
    if (this.props.showMIRCSModal !== this.state.showCSModal) {
      this.setState({ showCSModal: this.props.showMIRCSModal });
    }
  };
  generateLeftSideLists = (arrayOfList) => {
    if (arrayOfList.length > 0) {
      return arrayOfList.map((items, index) => {
        let url = `/results?query=${items.title}&sbQuery=${items.title
          }&q=All%20Fields&filters=&f1=taIRO&fval1=${items.title.replace(
            "/",
            "_"
          )}&f2=domain&fval2=IROs&fcount=2&cspath=iMedical Insights Reports-${items.title
          }&csproduct=''`;
        if (items.partition === "leftPart") {
          return (
            <li key={index} className="cs-mir-modalListing">
              <img
                src={iIcon}
                alt="i-icon"
                width={18}
                height={18}
                title={items.infoTitle}
                className="cs-list-i-icon"
              />
              <Link
                to={url}
                target="_blank"
                className="cs-modalLink"
                onClick={() => this.handelInsightsReportsLinks(items.title)}
              >
                {items.title}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </Link>
            </li>
          );
        }
      });
    }
  };
  generateRightSideLists = (arrayOfList) => {
    if (arrayOfList.length > 0) {
      return arrayOfList.map((items, index) => {
        let url = `/results?query=${items.title}&sbQuery=${items.title}&q=All%20Fields&filters=&f1=taIRO&fval1=${items.title}&f2=domain&fval2=IROs&fcount=2&cspath=iMedical Insights Reports-${items.title}&csproduct=''`;
        if (items.partition === "rightPart") {
          return (
            <li key={index} className="cs-mir-modalListing">
              <img
                src={iIcon}
                alt="i-icon"
                width={18}
                height={18}
                title={items.infoTitle}
                className="cs-tile-i-icon"
              />
              <Link
                to={url}
                target="_blank"
                className="cs-modalLink"
                onClick={() => this.handelInsightsReportsLinks(items.title)}
              >
                {items.title}
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </Link>
            </li>
          );
        }
      });
    }
  };
  handelInsightsReportsLinks = (title) => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      `Visited ${title}`,
      "",
      window.location.href,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      `iMedical Insights Reports-${title}`,
      ""
    );
  };
  onMouseEnterInfo = () => {
    this.setState({
      showInfo: true,
    });
  };
  onMouseLeaveInfo = () => {
    this.setState({
      showInfo: false,
    });
  };
  showDetails = () => {
    const ts = new trackingService();
    ts.indexTrackingData(
      localStorage.getItem("userdisplayName"),
      localStorage.getItem("wwid"),
      localStorage.getItem("username"),
      localStorage.getItem("function"),
      localStorage.getItem("region"),
      localStorage.getItem("userproducts"),
      localStorage.getItem("doctypepref"),
      localStorage.getItem("sid"),
      localStorage.getItem("deviceType"),
      localStorage.getItem("deviceOS"),
      localStorage.getItem("browserName"),
      localStorage.getItem("browserVersion"),
      localStorage.getItem("jnjDepartment"),
      localStorage.getItem("companyname"),
      "Expanded iMedical Insights Reports tile under content shortcuts",
      "",
      window.location.href
    );
    this.setState({ showCSModal: !this.state.showCSModal }, () => {
      this.props.handelMIRCardDetail(this.state.showCSModal);
    });
  };
  handleCloseModal = () => {
    this.setState({ showCSModal: false }, () => {
      this.props.handelMIRCardDetail(this.state.showCSModal);
    });
  };
  render() {
    // var privacyHtml = `
    //     <div class="cs-modalContent">
    //         <p>Integrated readouts: IROs are analysis of voice of customer data that uncover signal, themes, and actionable insights.</p>
    //     </div> `;
    return (
      <div className="GenAI-Recomm-ContentShortcutInnerWapper">
        {this.state.showCSModal && (
          <>
            <div className="gen-ai-cs-modalHeader"
              style={{ justifyContent: "center" }}
            >
              <div style={{ textAlign: "center", width: "100%" }}>
                <div class="modal-title">
                  <small
                    className="gen-ai-cs-modalTitle-MIRCS"
                    style={{ fontSize: "14px" }}
                  >
                    IMedical Digest are analysis of voice of
                    customer data that uncover signal, themes, and
                    actionable insights.
                  </small>
                </div>
              </div>
              <div className="gen-ai-cs-popup-cancel-btn-MIRCS popoverAvoidClickOutside" style={{ padding: '19px 8px 0 0' }}>
                <span className="popoverAvoidClickOutside" onClick={this.handleCloseModal}>
                  <svg className="popoverAvoidClickOutside" width="18px" height="18px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier"> <title>cancel</title>
                      <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                        <g id="work-case" fill="#afa7a7" transform="translate(91.520000, 91.520000)">
                          <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48">
                          </polygon>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div className="modal-body-height-genAI-MIRCS">
              <div className="iMedicalInsightsReports">
                <div className="gen-ai-cs-imir-modalList">
                  <ul style={{ listStyle: "none" }}>
                    {this.generateLeftSideLists(
                      this.state.arrayOfInsightsReports
                    )}
                  </ul>
                </div>
                <div
                  className="gen-ai-cs-imir-modalList"
                  style={{
                    marginTop: this.props.customWidth < 600 && "-15px",
                  }}
                >
                  <ul style={{ listStyle: "none" }}>
                    {this.generateRightSideLists(
                      this.state.arrayOfInsightsReports
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default MedicalInsightTileGenAIRec;
